import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

import { Flex } from 'Components/UI'
import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

const shouldForwardProp = prop => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Container = styled(Flex)
  .attrs({
    width: 1,
    justifyContent: 'center',
    mt: [32, 96],
  })
  .withConfig({ shouldForwardProp })`
  display: flex;
  position: relative;
  color: ${themeGet('colors.white')};
`
